import type { ContainerTemplate, NewContainer } from '@sr/types';
import { hasFilledContainers } from '../ContainerRows/containerFields';
import { templateRowsEqual } from './templateRows';

export const templateKey = (record: Pick<ContainerTemplate, 'partnerDwKey' | 'id'>) =>
  JSON.stringify([record.partnerDwKey, record.id]);

export type TemplateSelection = {
  selectedKey?: string;
  baseline?: NewContainer[];
  pending?: ContainerTemplate;
};
export const confirmTemplateSelection = (record: ContainerTemplate): TemplateSelection => ({
  selectedKey: templateKey(record),
  baseline: structuredClone(record.data.containers),
});
export const requestTemplateSelection = (
  state: TemplateSelection,
  rows: NewContainer[],
  record: ContainerTemplate,
): TemplateSelection =>
  (state.baseline ? !templateRowsEqual(rows, state.baseline) : hasFilledContainers(rows))
    ? { ...state, pending: record }
    : confirmTemplateSelection(record);

export const cancelTemplateSelection = (state: TemplateSelection): TemplateSelection => ({
  selectedKey: state.selectedKey,
  baseline: state.baseline,
});
